import API from "../../../../app/api";

/**
 * Get products by category / subcategory
 */
export const getProductsByCategory = async ({
    categorySlug,
    subCategorySlug,
    params = {},
}) => {
    try {
        const url = subCategorySlug
            ? `/products/${categorySlug}/${subCategorySlug}`
            : `/products/${categorySlug}`;

        const res = await API.get(url, { params });
        return res.data;
    } catch (error) {
        console.error("getProductsByCategory failed:", error);
        throw (
            error.response?.data ||
            new Error("Failed to fetch category products")
        );
    }
};

/**
 * Get PLP bottom banner
 */
export const getPLPBottomBanner = async () => {
    try {
        const res = await API.get("/banners/product-listing-bottom");
        return res;
    } catch (error) {
        console.error("getPLPBottomBanner failed:", error);
        throw (
            error.response?.data ||
            new Error("Failed to fetch PLP bottom banner")
        );
    }
};

/**
 * Get Best Seller banner
 */
export const getBestSellerBanner = async () => {
  try {
    const res = await API.get("/bestsellers/banner");
    if (!res.data?.success) {
      throw new Error("API failed");
    }
    return res.data.data;
  } catch (error) {
    console.error("getBestSellerBanner failed:", error);
    throw error;
  }
};
